import React from 'react';
import ColorFolder from '../doit/ColorFolder';
import TagsBar from './TagsBar';
import TaskCreator from './TaskCreator';
import { useTasksContext } from '../../providers/TasksContextProvider';
import PriosBar from './PriosBar';
import './Avoda.css';

// ---  Static  ---

// Create an object with initialized toggle state isSelected:false for each value in the list
export const createToggleState = (values, initSelected = false) => values.reduce((acc, value) => ({...acc, [value]: { isSelected: initSelected} }), {});

// Create a toggle "setter" function, based on a given setter function and its relevant value
export const createToggleHandler = (setState) => (value) => setState((prev) => ({...prev, [value]: {...prev[value], isSelected: !prev[value].isSelected }}));


// --- Avoda Component ---
//
const Avoda = () => {  

  // Toggled Tags cleared, Priorities all selected
  const {tags, prios} = useTasksContext();

  return (
    <div className='avoda'>
      <div className='tasksNTags'>
        <ColorFolder  filterTags={tags}
                      filterPrios={prios} // TODO: Add filterPrios prop
                      //filterStages={stages} filterPrios={prios}
                      key='avoda-1' 
                      />
        <div className='avodaTools'>
          <PriosBar />
          <TagsBar />
        </div>
      </div>
      <div className='avodaFooter'>
        <TaskCreator />
      </div>
    </div>
  );
};

export default Avoda;